export default {
  addAccount: '添加账号',
  name: '姓名',
  namePlaceholder: '请输入姓名',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  search: '搜索',
  phone: '手机号',
  phonePlaceholder: '请输入手机号',
  role: '角色',
  rolePlaceholder: '请选择角色',
  status: '状态',
  createTime: '创建时间',
  actions: '操作',
  edit: '编辑',
  disable: '禁用',
  enable: '启用',
  delete: '删除',
  active: '进行中',
  disabled: '已禁用',
  operation: '运营',
  addAccountTitle: '添加账号',
  editAccountTitle: '编辑账号',
  loginEmail: '请输入登录邮箱',
  selectCountry: '请选择国家/地区',
  password: '密码',
  passwordPlaceholder: '请输入密码',
  selectRole: '请选择角色',
  cancel: '取消',
  confirm: '确定',
  resetPassword: '重置密码',
  newPassword: '新密码',
  newPasswordPlaceholder: '请输入新密码',
  yes: '是',
  no: '否',
  confirmDelete: '确定删除该账号吗？',
};
